import React from 'react';
import {
	ColorSymbol,
	ColorWrapper,
	TooltipGrid,
	TooltipHeader,
	TooltipRowName,
	TooltipRowValue,
	TooltipWrapper,
} from './Tooltip.styles';
import { colors } from '@alixpartners/ui-components';
import { isNumber } from 'lodash';

const Tooltip = ({ tooltipData, header, color }) => {
	return (
		<TooltipWrapper>
			{header && <TooltipHeader>{header}</TooltipHeader>}
			<TooltipGrid>
				{tooltipData?.map((dt, index) => (
					<React.Fragment key={index}>
						<ColorWrapper>
							<ColorSymbol color={color ? color : colors.chartLightBlue} />
						</ColorWrapper>
						<TooltipRowName>{dt.name}</TooltipRowName>
						<TooltipRowValue>
							{isNumber(dt.value) ? dt.value.toFixed(2) : dt.value}
						</TooltipRowValue>
					</React.Fragment>
				))}
			</TooltipGrid>
		</TooltipWrapper>
	);
};

export default Tooltip;
